"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detailSchema = void 0;
var constants_1 = require("../../constants");
exports.detailSchema = {
    type: 'object',
    required: [],
    properties: {
        additionalSecuritiesHeldByBorrower: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_1.AdditionalSecuritiesHeldByBorrower), [null]),
            errorMessage: 'should be a valid AdditionalSecuritiesHeldByBorrower Enum value or null',
        },
        britishColumbiaYukonSaleClosingDate: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'should be a string with maximum of 100 characters or null',
        },
        calendarDaysDeferredCount: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'should be a string with maximum of 100 characters or null',
        },
        claimFilingExtensionObtained: {
            type: ['boolean', 'null'],
            errorMessage: 'should be among true or false or null',
        },
        contested: {
            type: ['boolean', 'null'],
            errorMessage: 'should be among true or false or null',
        },
        dateApprovedLenderNotifiedToSubmitClaim: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'should be a string with maximum of 100 characters or null',
        },
        dateLegalActionCompleted: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'should be a string with maximum of 100 characters or null',
        },
        dateLegalActionStarted: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'should be a string with maximum of 100 characters or null',
        },
        dateOfferAccepted: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'should be a string with maximum of 100 characters or null',
        },
        deficiencySaleClosingDate: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'should be a string with maximum of 100 characters or null',
        },
        deficiencySalePrice: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'should be a string with maximum of 100 characters or null',
        },
        dueDateOfLastCompleteInstallmentPaid: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'should be a string with maximum of 100 characters or null',
        },
        eviction: {
            type: ['boolean', 'null'],
            errorMessage: 'should be among true or false or null',
        },
        interestAdjustmentDate: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'should be a string with maximum of 100 characters or null',
        },
        interestAtDefaultRate: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'should be a string with maximum of 100 characters or null',
        },
        legalActionType: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_1.LegalActionType), [null]),
            errorMessage: 'should be a valid LegalActionType Enum value or null',
        },
        legalSystemType: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_1.LegalSystemType), [null]),
            errorMessage: 'should be a valid LegalSystemType Enum value or null',
        },
        mainClaimDueDate: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'should be a string with maximum of 100 characters or null',
        },
        mobileHomeOnLeasedLand: {
            type: ['boolean', 'null'],
            errorMessage: 'should be among true or false or null',
        },
        mortgageType: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_1.MortgageType), [null]),
            errorMessage: 'should be a valid MortgageType Enum value or null',
        },
        otherLegalActionType: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'should be a string with maximum of 100 characters or null',
        },
        propertyOccupancyStatus: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_1.PropertyOccupancyStatus), [null]),
            errorMessage: 'should be a valid PropertyOccupancyStatus Enum value or null',
        },
        propertySoldBy: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_1.PropertySoldBy), [null]),
            errorMessage: 'should be a valid PropertySoldBy Enum value or null',
        },
        propertyTransferredBy: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_1.PropertyTransferredBy), [null]),
            errorMessage: 'should be a valid PropertyTransferredBy Enum value or null',
        },
        propertyVacancyDate: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'should be a string with maximum of 100 characters or null',
        },
        propertyVacatedBy: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_1.PropertyVacatedBy), [null]),
            errorMessage: 'should be a valid PropertyVacatedBy Enum value or null',
        },
        realEstateCommissionPaid: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'should be a string with maximum of 100 characters or null',
        },
        representativeToObtainKey: {
            type: 'object',
            required: [],
            properties: {
                fullName: {
                    type: ['string', 'null'],
                    minLength: 0,
                    maxLength: 100,
                    errorMessage: 'should be a string with maximum of 100 characters or null',
                },
                phoneNumber: {
                    type: ['string', 'null'],
                    minLength: 0,
                    maxLength: 100,
                    errorMessage: 'should be a string with maximum of 100 characters or null',
                },
            },
        },
        taxAccountBalanceAmount: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'should be a string with maximum of 100 characters or null',
        },
        taxAccountBalanceType: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_1.TaxAccountBalanceType), [null]),
            errorMessage: 'should be a valid TaxAccountBalanceType Enum value or null',
        },
        typeOfClaim: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_1.TypeOfClaim), [null]),
            errorMessage: 'should be a valid TypeOfClaim Enum value or null',
        },
        unpaidPrincipalBalanceAmount: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'should be a string with maximum of 100 characters or null',
        },
        warrantyType: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_1.WarrantyType), [null]),
            errorMessage: 'should be a valid WarrantyType Enum value or null',
        },
    },
};
exports.default = exports.detailSchema;
